let prefix = '/api/warehouse';
function store(data){
    return window.axios.post(prefix+'/goods-issue', data);
}
export default {
    store
}